import React, { useState, useEffect } from 'react';
import './GalleryAndTestimonials.css';

const GalleryAndTestimonials = () => {
  const galleryItems = [
    { image: 'https://www.mitsubishi-forklift.co.uk/hubfs/A_UK/Power%20Pallet%20Trucks/PREMIAESSBPN3-MINAPP-HIWEB-19-L.jpg', caption: 'Bulk Loading' },
    { image: 'https://cms.ar-racking.com/uploads/2021/03/tipos-stock-almacen-3.jpg', caption: 'Stock Ready' },
    { image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80', caption: 'Warehouse Flow' },
    { image: 'https://www.productoftheyear.co.uk/wp-content/uploads/2024/01/0007-No-LoveRaw-1-scaled.jpg', caption: 'Product Packs' },
    { image: 'https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80', caption: 'Frozen Zone' },
  ];

  const testimonials = [
    { quote: 'Nand’s bulk deals keep my store stocked and my margins healthy—fast delivery every time!', author: 'Amir Khan', role: 'Retailer, London' },
    { quote: 'From snacks to cleaning supplies, Nand’s prices and service are unbeatable for my catering business.', author: 'Emma Patel', role: 'Caterer, Birmingham' },
    { quote: 'Their pallet deals on beverages saved my cafe a fortune—reliable and top quality!', author: 'Liam O’Connor', role: 'Cafe Owner, Manchester' },
    { quote: 'Nand’s wholesale soaps and wipes are a hit at my market stall—great value, great support.', author: 'Sonia Gupta', role: 'Market Vendor, Leeds' },
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="gallery-testimonial-section">
      <div className="gallery-testimonial-container">
        <div className="gallery">
          <h2 className="gallery-title">Inside Nand's Operations</h2>
          <div className="gallery-stack">
            {galleryItems.map((item, index) => (
              <div key={index} className="gallery-item">
                <img src={item.image} alt={item.caption} className="gallery-image" />
                <span className="gallery-caption">{item.caption}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="testimonials">
          <h2 className="testimonial-title">Trusted by Our Customers</h2>
          <div className="trust-score">4.9/5 from 200+ Reviews</div>
          <div className="testimonial-display">
            <div className="testimonial-card">
              <p className="testimonial-quote">{testimonials[currentTestimonial].quote}</p>
              <p className="testimonial-author">{testimonials[currentTestimonial].author}</p>
              <p className="testimonial-role">{testimonials[currentTestimonial].role}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryAndTestimonials;